import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import './index.css';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { InvitePage } from './pages/InvitePage';
import { CampaignPage } from './pages/CampaignPage';
import { RecruitmentPage } from './pages/RecruitmentPage';
import { IndexPage } from './pages/IndexPage';
import { Activity358 } from './pages/Activity358';
import { EnglishInvitePage } from './pages/EnglishInvitePage';
import OverseasSharing from './pages/OverseasSharing';
import Fail from './pages/OverseasSharing/Fail';
import Success from './pages/OverseasSharing/Success';
import Warning from './pages/OverseasSharing/Warning';
import { WeChat } from './pages/Wechat';
import { WrongPage } from './pages/WrongPage';
import { WeChatError } from './pages/Wechat-Error';
import { WeChatSuccess } from './pages/Wechat-Success';
import 'bootstrap/dist/css/bootstrap.min.css';
import ContentShare from './pages/Content-Share';
import { ContentShareRegister } from './pages/Content-Share-Register';
import { VankePage } from './pages/Vanke';
import { InviteSFPage } from './pages/InviteSFPage';
import { NewInvitePage } from './pages/NewInvitePage';
import { YearPage } from './pages/YearPage';
import PCModal from './pages/PCModal';

import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/trial/activity">
        <InvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/pcModal">
        <PCModal logo={''} inviterId={''} qrcode={''} trailId={''} privilegesDays={''}
                 activityTime={''} description={''} userRegisterType={''} state={''}/>
      </Route>
      <Route path="/trial/newInvitePage">
        <NewInvitePage logo={''} inviterId={''} qrcode={''} trailId={''} privilegesDays={''}
                       activityTime={''} description={''} userRegisterType={''} state={''}/>
      </Route>
      <Route path="/trial/activity">
        <InvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/activity-sf">
        <InviteSFPage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/bookActivity">
        <InvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/activity-kw">
        <InvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/activity-358">
        <Activity358 logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/invite">
        <InvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route exact path="/trial/wechat">
        <WeChat logo={''} inviterId={''} trailId={''} qrcode={''} state={''}/>
      </Route>
      <Route exact path="/trial/wechat/fail">
        <WeChatError logo={''} inviterId={''} trailId={''} qrcode={''} error={''}/>
      </Route>
      <Route exact path="/trial/wechat/success">
        <WeChatSuccess logo={''} inviterId={''} trailId={''} qrcode={''} state={''}/>
      </Route>
      <Route exact path="/trial/facebook-share">
        <OverseasSharing trailId={''} userId={''} state={''}/>
      </Route>
      <Route path="/trial/facebook-share/fail">
        <Fail/>
      </Route>
      <Route path="/trial/facebook-share/success">
        <Success/>
      </Route>
      <Route path="/trial/facebook-share/warning">
        <Warning/>
      </Route>
      <Route path="/trial/en/campaign_auslogics">
        <EnglishInvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/en/campaign_oidatechtips">
        <EnglishInvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/en/campaign_etechgeeks">
        <EnglishInvitePage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/en/campaign_giveawayoftheday">
        <CampaignPage logo={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/trial/content/share">
        <ContentShare/>
      </Route>
      <Route path="/trial/content-share/register">
        <ContentShareRegister recordShare={''} source={''} logo={''} contentId={''} inviterId={''} trailId={''} state={''}/>
      </Route>
      <Route path="/recruitment">
        <RecruitmentPage/>
      </Route>
      <Route path="/trial/vanke">
        <VankePage logo={''} inviterId={''} trailId={''} qrcode={''} state={''}/>
      </Route>
      <Route path="/trial/yearPage">
        <YearPage logo={''} inviterId={''} qrcode={''} trailId={''} privilegesDays={''} activityTime={''} description={''} userRegisterType={''} state={''}/>
      </Route>
      <Route path="/">
        <IndexPage/>
      </Route>
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
